const React = require('react')
const { useState, useEffect } = require('react')
const { useHistory } = require('react-router-dom')
const { Row, Col, UncontrolledTooltip } = require('reactstrap')
const { useResponsive, BREAKPOINTS } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner } = require('@components')

require('@styles/pages/block/blob.block.css')

const BlockBlob = props => {
    const { loading, data } = props
    const history = useHistory()
    const { network } = useNetworkConfig()
    const isMobile = useResponsive(BREAKPOINTS.small)

    const [blobDetails, setBlobDetails] = useState([])

    useEffect(() => {
        if (!data) return

        const fields = {
            blobTx: {
                id: 'block-blob-tx',
                label: 'Blob Tx',
                value: (
                    <>
                        {data.blobTransactionCount === 0 ? (
                            <>{data.blobTransactionCount} transaction</>
                        ) : (
                            <span
                                className={`${network.name}-text-color cursor-pointer`}
                                onClick={() => {
                                    history.push(`/${network.name}/txs/?block=${data.number}&isBlob=true`)
                                }}
                            >
                                {data.blobTransactionCount} transaction
                                {data.blobTransactionCount === 1 ? '' : 's'}
                            </span>
                        )}
                    </>
                ),
                tooltip: 'The number of blob transaction in this block.'
            },
            blobSize: {
                id: 'block-blob-size',
                label: 'Blob Size',
                value: (
                    <>
                        {128 * data.blobCount} KiB ({data.blobCount} blobs)
                    </>
                ),
                tooltip: 'The blob size in this block.'
            },
            blobGasPrice: {
                id: 'block-blob-gas-price',
                label: 'Blob Gas Price',
                value: (
                    <>
                        {(data.blobGasPrice / 10 ** 18).toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 18
                        })}
                        &nbsp;
                        {network.data.token}&nbsp;
                        <span style={{ color: 'var(--grey-color)' }}>({data.blobGasPrice.toLocaleString()} wei)</span>
                    </>
                ),
                tooltip: `Cost per unit of blob gas spent for the transaction, in ${network.data.token} and Gwei.`
            },
            blobGasUsed: {
                id: 'block-blob-gas-used',
                label: 'Blob Gas Used',
                value: (
                    <>
                        {data.blobGasUsed.toLocaleString()}
                        &nbsp;
                        <span style={{ color: 'var(--grey-color)' }}>
                            ({((data.blobGasUsed / data.blobGasLimit) * 100).toLocaleString()}%)
                        </span>
                    </>
                ),
                tooltip: 'The total blob gas used in this block and its percentage of gas filled in this block.'
            },
            blobGasLimit: {
                id: 'block-blob-gas-limit',
                label: 'Blob Gas Limit',
                value: <>{data.blobGasLimit.toLocaleString()}</>,
                tooltip: 'Maximum amount of blob gas allocated for the transaction & the amount eventually used.'
            }
        }

        const blobOrder = ['blobTx', 'blobSize', 'blobGasPrice', 'blobGasUsed']

        setBlobDetails(blobOrder.map(key => fields[key]))
    }, [data])

    return (
        <div className='box table-section'>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    {blobDetails.map(item => (
                        <Row className='table-info-row' noGutters>
                            {item.id === 'divider' ? (
                                <div className='table-divider' />
                            ) : (
                                <>
                                    <Col xs={12} sm={4} className='d-flex align-items-start'>
                                        <span className='info-icon-wrapper' id={item.id}>
                                            <i className='fas fa-question-circle info-icon' />
                                        </span>
                                        <span className='info-label'>{item.label}:</span>
                                    </Col>
                                    <UncontrolledTooltip placement='top' target={item.id}>
                                        {item.tooltip}
                                    </UncontrolledTooltip>
                                    <Col
                                        xs={12}
                                        sm={8}
                                        className={`d-flex align-items-center ${isMobile && 'mt-2'}`}
                                        style={{ flexWrap: 'wrap', wordBreak: 'break-all' }}
                                    >
                                        <span className='info-value' style={{ width: '100%' }}>
                                            {item.value}
                                        </span>
                                    </Col>
                                </>
                            )}
                        </Row>
                    ))}
                </>
            )}
        </div>
    )
}

module.exports = { BlockBlob }
